<template>
  <div id="app">

    <AudioPlayer :route="currentRoute"/>

    <router-view v-if="browser.platform.type == 'desktop' && browser.browser.name != 'Safari'" class="hidden? xl:flex?"/>

    <div v-if="browser.platform.type != 'desktop' || browser.browser.name == 'Safari'" class="flex flex-col xl:hidden? h-screen w-full mobile">

      <h1 class="font-bold text-5xl mt-16 leading-none p-6">
        For the best
        <br>experience
        <br>we invite you
        <br>to visit

        <span v-if="browser.platform.type != 'desktop'"> from <br>your desktop</span>

        <span v-if="browser.browser.name == 'Safari'" class="text-5xl">
          <br>using Chrome
        </span>

      </h1>
    </div>


  </div>
</template>

<script>

import AudioPlayer from "@/components/AudioPlayer.vue";
import Bowser from "bowser";

export default {
  name: 'App',
  components:{
    AudioPlayer
  },
  data(){
    return{
      currentRoute: this.$route.name,
      browser: Bowser.parse(window.navigator.userAgent),
    }
  }
}
</script>

<style>

@import url('https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,700;1,600&display=swap');
@font-face {
font-family: "AvantGarde";
src: url("/assets/styles/ITC Avant Garde Gothic LT Bold.otf") format("opentype");
font-style: normal;
}

#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif; */
  font-family: Arial, Helvetica Neue, Helvetica, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2b2b2b;
}

#invitation-style{
  font-family: 'Open Sans', sans-serif;
}

#MarkOnly-style{
  font-family: 'AvantGarde', Arial, sans-serif;
  font-weight: 800;
}

.mobile{
  background-color: #e3d0a5;
  color: #1c1c1a;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
